
import React from "react";
import { formatCurrency } from '../../utils/calculator';

interface ContributionBreakdownSummaryProps {
  incomeContributionWeekly: number;
  assetContributionWeekly: number;
  deferredAmount: number;
  isUsingLoan: boolean;
}

export function ContributionBreakdownSummary({
  incomeContributionWeekly,
  assetContributionWeekly,
  deferredAmount,
  isUsingLoan
}: ContributionBreakdownSummaryProps) {
  return (
    <div className="bg-white p-6 rounded-lg border">
      <div className="flex items-center justify-between mb-4">
        <p className="font-medium">From Income</p>
        <p className="font-semibold text-grandpal-green">
          {formatCurrency(incomeContributionWeekly)}/week
        </p>
      </div>
      <div className="flex items-center justify-between">
        <p className="font-medium">From Assets</p>
        <p className="font-semibold text-grandpal-green">
          {formatCurrency(isUsingLoan 
            ? assetContributionWeekly - deferredAmount 
            : assetContributionWeekly)}/week
        </p>
      </div>
      
      {isUsingLoan && (
        <div className="text-sm mt-2 border-t pt-2">
          <p className="flex items-center justify-between text-amber-700">
            <span>Deferred via loan</span>
            <span>{formatCurrency(deferredAmount)}/week</span>
          </p>
        </div>
      )}
    </div>
  );
}
